<df-base-nav-link
  *ngIf="!userService.User?.isSemrushPlan()"
  class="ml-1"
  id="discord-icon-widget"
  [name]="'Navigation.Discord' | translate"
  href="https://discord.com/invite/82M7NcAs68"
  [iconSrc]="'/assets/img/icon_discord.svg'"
></df-base-nav-link>

<!-- Notification -->
<df-base-nav-link
  *ngIf="!userService.User?.isSemrushPlan()"
  id="notification-icon-widget"
  [name]="'Navigation.Notification' | translate"
  [routerLinkUrl]="[]"
  [iconSrc]="'/assets/img/ic_bell.svg'"
  [notificationsCount]="notificationsCount"
  (click)="showNovuNotifications()"
></df-base-nav-link>

<!-- Help Center -->
<tui-hosted-dropdown
  class="w-full mb-2"
  tuiDropdownAlign="left"
  [(open)]="helpDropdownOpen"
  [content]="helpDropdown"
  *ngIf="!userService.User?.isSemrushPlan()"
>
  <div tuiHostedDropdownHost>
    <df-base-nav-link
      [iconSrc]="'/assets/img/ic_question_circle.svg'"
      [name]="'Navigation.Help' | translate"
      href=""
      [routerLinkUrl]="[]"
    ></df-base-nav-link>
  </div>
</tui-hosted-dropdown>

<!-- User -->
<hr class="menu__border menu__border--user tui-accent-16-bg" />
<df-base-left-side-navigation-footer-user class="mb-2"></df-base-left-side-navigation-footer-user>

<!-- Footer -->
<p
  *ngIf="xPartnerService.isPartner"
  class="powered-by-text text-white text-xs text-center mb-2"
>
  {{ 'Navigation.Powered by' | translate }}
  <a
    href="https://www.digitalfirst.ai/platform"
    target="_blank"
    class="text-xs no-underline"
  >
    {{ 'Navigation.Digital First AI' | translate }}
  </a>
</p>

<ng-template #helpDropdown>
  <tui-data-list #helpCenterList>
    <a
      tuiOption
      (click)="closeDropdownAndOpenUrl('https://help.digitalfirst.ai/')"
      class="tui-text-01 flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        src="/assets/img/ic_question_circle.svg"
        class="mr-2"
      ></svg-icon>
      {{ 'Navigation.Help Center' | translate }}
    </a>

    <a
      tuiOption
      (click)="
        closeDropdownAndOpenUrl(
          'https://help.digitalfirst.ai/en/articles/9115766-see-youtube-videos-explaining-the-most-important-features'
        )
      "
      class="tui-text-01 flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        src="/assets/img/ic_presentation_play.svg"
        class="mr-2"
        [svgStyle]="{ width: '24px', height: '24px' }"
      ></svg-icon>
      {{ 'Navigation.Video Tutorials' | translate }}
    </a>

    <a
      tuiOption
      (click)="eventsService.showIntercome()"
      class="tui-text-01 flex justify-start tui-text-body-m-2"
    >
      <svg-icon
        src="/assets/img/ic_chat.svg"
        class="mr-4 relative left-[3px]"
        [svgStyle]="{ width: '18px', height: '18px' }"
      ></svg-icon>
      {{ 'Navigation.Live chat' | translate }}
    </a>
  </tui-data-list>
</ng-template>
